const LEAD_URL = 'https://lk.moe-sobranie.ru/api/landings/lead';

export class ContactFormClass {
  constructor(formId) {
    this.form = document.getElementById('contact-form');
    if (!this.form) {
      console.warn(`Форма с id="${formId}" не найдена`);
      return;
    }

    this.fields = {
      name: {
        element: document.getElementById("contact-form-input-name"),
        error: document.getElementById("contact-form-input-name-error"),
        validate: this.validateName.bind(this),
      },
      email: {
        element: document.getElementById("contact-form-input-email"),
        error: document.getElementById("contact-form-input-email-error"),
        validate: this.validateEmail.bind(this),
      },
      phone: {
        element: document.getElementById("contact-form-input-phone"),
        error: document.getElementById("contact-form-input-phone-error"),
        validate: this.validatePhone.bind(this),
      },
      message: {
        element: document.getElementById("contact-form-input-message"),
        error: document.getElementById("contact-form-input-message-error"),
        validate: this.validateMessage.bind(this),
      },
    };

    this.policyInput = document.getElementById("contact-form-input-policy");
    this.policyError = document.getElementById("contact-form-input-policy-error");

    this.successMessage = document.querySelector(".contacts__success");
    this.successMessageReturnButton = document.querySelector(
      ".contacts__success__return-button"
    );

    this.init();
  }

  init() {
    Object.values(this.fields).forEach((field) => {
      if (!field.element || !field.error) return;

      // При вводе: скрываем ошибку, если поле стало валидным
      field.element.addEventListener("input", () => {
        const value = field.element.value.trim();
        const validationResult = field.validate(value);
        if (validationResult.isValid) {
          this.showSuccess(field);
        }
        // Ошибку НЕ показываем — ждём blur
      });

      // При потере фокуса — валидируем и показываем ошибку с анимацией
      field.element.addEventListener("blur", () => {
        this.validateFieldOnBlur(field);
      });
    });

    if (this.policyInput) {
      this.policyInput.addEventListener("change", () => {
        if (this.policyInput.checked) {
          this.clearPolicyError();
        }
      });
    }

    // Отправка формы
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      const isFormValid = this.validateForm();
      const isPolicyValid = this.validatePolicy();
      if (isFormValid && isPolicyValid) {
        this.submitForm();
      }
    });

    // Кнопка "Вернуться" после успешной отправки
    if (this.successMessageReturnButton) {
      this.successMessageReturnButton.addEventListener("click", () => {
        this.form.classList.remove("contacts__form_hidden");
        if (this.successMessage) {
          this.successMessage.classList.add("contacts__success_hidden");
        }
      });
    }
  }

  validateFieldOnBlur(field) {
    const { element, error, validate } = field;
    if (!element || !error) return;

    const value = element.value.trim();
    const validationResult = validate(value);

    if (validationResult.isValid) {
      this.showSuccess(field);
    } else {
      this.showErrorWithAnimation(field, validationResult.message);
    }
  }

  validateForm() {
    let isValid = true;
    Object.values(this.fields).forEach((field) => {
      if (!field.element || !field.error) return;

      const value = field.element.value.trim();
      const validationResult = field.validate(value);

      if (validationResult.isValid) {
        this.showSuccess(field);
      } else {
        this.showErrorWithAnimation(field, validationResult.message);
        isValid = false;
      }
    });
    return isValid;
  }

  validatePolicy() {
    if (!this.policyInput) return true;

    if (this.policyInput.checked) {
      this.clearPolicyError();
      return true;
    }

    this.showPolicyError();
    return false;
  }

  showPolicyError() {
    this.policyInput?.closest(".consent")?.classList.add("consent_error");
    this.policyError?.classList.add("input-error_visible");
  }

  clearPolicyError() {
    this.policyInput?.closest(".consent")?.classList.remove("consent_error");
    this.policyError?.classList.remove("input-error_visible");
  }

  // === Валидаторы ===
  validateName(value) {
    if (!value) return { isValid: false, message: "Поле обязательно для заполнения" };
    if (value.length < 2) return { isValid: false, message: "Имя должно содержать минимум 2 символа" };
    if (value.length > 50) return { isValid: false, message: "Имя не должно превышать 50 символов" };
    if (!/^[a-zA-Zа-яА-ЯёЁ\s\-]+$/.test(value)) return { isValid: false, message: "Имя может содержать только буквы, пробелы и дефисы" };
    return { isValid: true, message: "" };
  }

  validateEmail(value) {
    if (!value) return { isValid: false, message: "Поле обязательно для заполнения" };
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(value)) return { isValid: false, message: "Введите корректный email адрес" };
    return { isValid: true, message: "" };
  }

  validatePhone(value) {
    if (!value) return { isValid: false, message: "Поле обязательно для заполнения" };
    const cleanValue = value.replace(/[\s\-\(\)]/g, "");
    if (!cleanValue.startsWith("+7")) return { isValid: false, message: "Номер должен начинаться с +7" };
    if (cleanValue.length !== 12) return { isValid: false, message: "Номер должен содержать 11 цифр (включая 7)" };
    if (!/^\d+$/.test(cleanValue.substring(2))) return { isValid: false, message: "После +7 должны быть только цифры" };
    return { isValid: true, message: "" };
  }

  validateMessage(value) {
    // В текущей реализации сообщение не обязательно
    // Если захотите сделать обязательным — раскомментируйте:
    /*
    if (!value.trim()) {
      return { isValid: false, message: "Поле обязательно для заполнения" };
    }
    if (value.length > 1000) {
      return { isValid: false, message: "Сообщение не должно превышать 1000 символов" };
    }
    */
    return { isValid: true, message: "" };
  }

  // === UI: показ с анимацией ===
  showErrorWithAnimation(field, message) {
    const { element, error } = field;
    if (!element || !error) return;

    element.classList.add("input_error");
    error.textContent = message;

    // Триггер CSS transition
    error.classList.remove("input-error_visible");
    void error.offsetWidth; // force reflow
    error.classList.add("input-error_visible");

    element.setAttribute("aria-invalid", "true");
  }

  showSuccess(field) {
    const { element, error } = field;
    if (!element || !error) return;

    element.classList.remove("input_error");
    error.textContent = "";
    error.classList.remove("input-error_visible");
    element.setAttribute("aria-invalid", "false");
  }

  submitForm() {
    const formData = new FormData(this.form);
    const data = Object.fromEntries(
      Array.from(formData.entries()).map(([key, value]) => [key, String(value)])
    );

    if (typeof ym === "function") {
      ym(104549080, "reachGoal", "contact_us_form_success");
    }

    fetch(LEAD_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Ошибка сервера: ${response.status}`);
        }
      })
      .then(() => {
        this.form.reset();
        this.form.classList.add("contacts__form_hidden");
        if (this.successMessage) {
          this.successMessage.classList.remove("contacts__success_hidden");
        }
      })
      .catch(error => {
        console.error('Ошибка при отправке формы:', error);
      });
  }
}